import { Link } from 'react-router-dom';
import {
  TemplateContainer,
  TemplateImage,
  TryButton,
  VideoDuration,
  VideoPreview,
} from '@picsart/growth-rc/Template';
import { useTranslator } from '@picsart/rc/services/localization';
import buildSlugFromNameAndId from 'utils/buildSlugFromNameAndId';
import templateEditorPath from 'constants/templates';
import addAnalyticsParamsToUrl from 'utils/addAnalyticsParamsToUrl';
import { useEffect, useState } from 'react';
import { getSingleTemplate } from 'templates/api';
import TemplateItemProps from './types';
import useStyles from './styles';

const TemplateItem = ({ template }: TemplateItemProps) => {
  const classes = useStyles();
  const translate = useTranslator();
  const [singleTemplateCategory, setSingleTemplateCategory] = useState(null);
  const buttonLabel = translate('Try it out');
  const { display_name, id } = template;

  useEffect(() => {
    if (template?.subtypes && template?.subtypes?.length > 0) {
      setSingleTemplateCategory(template?.subtypes[0]);
    } else {
      getSingleTemplate(String(id))
        .then(({ templateData }) => {
          setSingleTemplateCategory(templateData?.subtypes[0]);
        })
        .catch(error => {
          console.error('Error loading template:', error);
        });
    }
  }, [id]);

  const formattedCategory = singleTemplateCategory
    ? encodeURI(singleTemplateCategory.replace(/-/g, '+'))
    : '';

  const redirectTemplateUrl = `/template/${buildSlugFromNameAndId({ id, name: display_name })}`;
  const buttonLink = addAnalyticsParamsToUrl(
    `${templateEditorPath}${id}&category=templates${
      formattedCategory && `&templateSearch=${formattedCategory}`
    }`,
    {
      source: 'templates',
      origin: 'template_item',
    },
  );

  return (
    <div data-testid="template-item">
      <TemplateContainer
        template={template}
        buttonLabel={buttonLabel}
        className={classes.root}
        buttonLink={buttonLink}
      >
        <Link to={redirectTemplateUrl}>
          <TemplateImage />
        </Link>
        <TryButton />
        <Link to={redirectTemplateUrl}>
          <VideoPreview />
        </Link>
        <VideoDuration />
      </TemplateContainer>
    </div>
  );
};

export default TemplateItem;
